<ng-container *ngIf="statisticsProductsWithStatus$ | async as data">
  <ng-container *ngIf="data.statisticsProducts">
    <h3 class="rs-tit5">
      {{ 'nsp.manage.statistics.title.period' | translate }},<br />{{
        'nsp.manage.statistics.title.content' | translate
      }}
    </h3>
    <div class="rs-flex-row">
      <div class="rs-flex-columns small-12 medium-3">
        <div class="rs-panel-flex rs-emphasis-light">
          <div class="rs-panel-flex-cell rs-bg-grey2">
            <p class="text-center rs-font-pxB">
              <span class="rs-txt-s13 rs-txt-primary">{{ data.statisticsProducts.total }}</span
              ><br />
              {{ 'nsp.manage.statistics.cybermenaces' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="rs-flex-columns rs-flex-middle small-12 medium-1">
        <p class="text-center">{{ 'nsp.manage.statistics.which' | translate }}</p>
      </div>
      <div class="rs-flex-columns small-12 medium-8">
        <div class="rs-panel-flex">
          <div class="rs-panel-flex-cell rs-bg-grey2">
            <div class="rs-flex-row rs-flex-middle rs-maxh">
              <div class="rs-flex-columns small-6 medium-3">
                <p class="text-center rs-font-pxB">
                  <span class="rs-txt-s9 rs-txt-primary">{{
                    data.statisticsProducts.malwares
                  }}</span
                  ><br />
                  {{ 'nsp.manage.statistics.malwares' | translate }}
                  <span
                    class="has-tip"
                    [title]="'nsp.manage.statistics.definition.malwares' | translate"
                    ><i class="icon-Information-box icon-lh" aria-hidden="true"></i
                  ></span>
                </p>
              </div>
              <div class="rs-flex-columns small-6 medium-3">
                <p class="text-center rs-font-pxB">
                  <span class="rs-txt-s9 rs-txt-primary">{{
                    data.statisticsProducts.phishing
                  }}</span
                  ><br />
                  {{ 'nsp.manage.statistics.phising' | translate }}
                  <span
                    class="has-tip"
                    [title]="'nsp.manage.statistics.definition.phising' | translate"
                    ><i class="icon-Information-box icon-lh" aria-hidden="true"></i
                  ></span>
                </p>
              </div>
              <div class="rs-flex-columns small-6 medium-3">
                <p class="text-center rs-font-pxB">
                  <span class="rs-txt-s9 rs-txt-primary">{{ data.statisticsProducts.crypto }}</span
                  ><br />
                  {{ 'nsp.manage.statistics.crypto' | translate }}
                  <span
                    class="has-tip"
                    [title]="'nsp.manage.statistics.definition.crypto' | translate"
                    ><i class="icon-Information-box icon-lh" aria-hidden="true"></i
                  ></span>
                </p>
              </div>
              <div class="rs-flex-columns small-6 medium-3">
                <p class="text-center rs-font-pxB">
                  <span class="rs-txt-s9 rs-txt-primary">{{
                    data.statisticsProducts.commands
                  }}</span
                  ><br />
                  {{ 'nsp.manage.statistics.commands' | translate }}
                  <span
                    class="has-tip"
                    [title]="'nsp.manage.statistics.definition.commands' | translate"
                    ><i class="icon-Information-box icon-lh" aria-hidden="true"></i
                  ></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-me"></div>
  </ng-container>

  <ng-container *ngIf="data.isPendingStatistics">
    <div class="panel clearfix">
      <div class="panel rs-h-s5 rs-margin-bottom1-m rs-wd-s30 rs-bg-skeleton rs-anim-loading"></div>
      <div class="panel rs-h-s12 rs-bg-skeleton rs-anim-loading"></div>
    </div>
    <div class="rs-me"></div>
  </ng-container>

  <ng-container *ngIf="data.errorStatistics">
    <lib-generic-message-box [messageType]="MessageBoxTypesEnum.Error">
      <p Title>{{ 'nsp.manage.statistics.error.title' | translate }}</p>
      <p Content>{{ 'nsp.manage.statistics.error.content' | translate }}</p>
    </lib-generic-message-box>
  </ng-container>
</ng-container>
